import { createAction } from 'Lib/reduxUtils';

import {
  SEND_TERMS_UPDATE_ACCEPTED,
  SET_APP_START_INFO,
  SET_CHAT_SUGGESTION_CONSENT_SHOWN,
  SET_CHAT_SUGGESTIONS_CONSENTS,
  SET_CHAT_SUGGESTIONS_CONSENTS_SUCCESS,
  SET_DISTANCE_UNIT,
  SET_IS_HUBBLE_DEBUGGER_ENABLED,
  SET_THEME_DEVICE_PREFERENCE,
  SET_THEME_PREFERENCE,
  TOGGLE_CONSUMABLES,
  TOGGLE_GOLD,
  TOGGLE_PLATINUM,
  TOGGLE_RECS_TOOLBAR,
  TOGGLE_TINDER_PLUS,
} from './constants';
import { ChatSuggestionConsents, DistanceUnit, SparksThemeId, ThemeId } from './types';

export const sendTermsUpdateAccepted = createAction(SEND_TERMS_UPDATE_ACCEPTED);

export const setChatSuggestionsConsentShown = createAction(
  SET_CHAT_SUGGESTION_CONSENT_SHOWN,
  (shown: boolean) => shown
);
export const setChatSuggestionsConsents = createAction(
  SET_CHAT_SUGGESTIONS_CONSENTS,
  (result: { consentAction: string }) => result
);
export const setChatSuggestionConsentsSuccess = createAction(
  SET_CHAT_SUGGESTIONS_CONSENTS_SUCCESS,
  (result: ChatSuggestionConsents) => result
);
export const toggleConsumables = createAction(TOGGLE_CONSUMABLES, (enabled: boolean) => enabled);
export const toggleGold = createAction(TOGGLE_GOLD, (enabled: boolean) => enabled);
export const togglePlatinum = createAction(TOGGLE_PLATINUM, (enabled: boolean) => enabled);
export const toggleRecsToolbar = createAction(TOGGLE_RECS_TOOLBAR, (enabled: boolean) => enabled);
export const toggleTinderPlus = createAction(TOGGLE_TINDER_PLUS, (enabled: boolean) => enabled);

export const setAppStartInfo = createAction(SET_APP_START_INFO, (enabled: any) => enabled);
export const setThemeDevicePreference = createAction(
  SET_THEME_DEVICE_PREFERENCE,
  (themeDevicePreference: ThemeId) => themeDevicePreference
);
export const setThemePreference = createAction(
  SET_THEME_PREFERENCE,
  (themePreference: ThemeId | SparksThemeId | null) => themePreference
);

export const setDistanceUnit = createAction(SET_DISTANCE_UNIT, (unit: DistanceUnit) => unit);

export const setIsHubbleDebuggerEnabled = createAction(
  SET_IS_HUBBLE_DEBUGGER_ENABLED,
  (enabled: boolean) => enabled
);
